export default {
  namespaced: true,

  state: {
    apiList: [],
    apiParams: [],
    testData: {}
  },
  getters: {
    apiParamsFilter(state) {
      const requiredList = [];
      const unRequiredList = [];

      state.apiParams.forEach(item => {
        // 1 为必选，0 为非必须按
        const { paramInput: isRequired } = item;

        isRequired ? requiredList.push(item) : unRequiredList.push(item);
      });

      return {
        requiredList,
        unRequiredList
      };
    },
    clientDemo(state) {
      return state.testData && state.testData.clientDemo;
    },
    responseDemo(state) {
      return state.testData && state.testData.responseDemo;
    },
    reuqestDemo(state) {
      return state.testData && state.testData.reuqestDemo;
    }
  },
  actions: {
    async getApiList(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post("/server/portal/api/index", data);
      commit("setApiList", res.data.data.catalogList);
    },
    async queryApiParams(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post("/server/portal/api/apiParam", data);
      commit("setApiParams", res.data.data);
    },
    async apiTest(
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post("/server/portal/test/execute", data);
      commit("setTestData", res.data.data);
    }
  },

  mutations: {
    setApiList(state, data) {
      state.apiList = data;
    },
    setTestData(state, data) {
      state.testData = data;
    },
    setApiParams(state, data) {
      state.apiParams = data;
    }
  }
};
